<template>
  <li ref="courseSkillWrap">
    <div class="titleArea">
      <div class="title">
        {{ t("advance-track", 1) }} {{ index + 1 }}
        <p>{{ assessmentSet.trackTitle }} - {{ assessmentSet.trackLevelTitle }}</p>
      </div>
      <ul class="labelWrap">
        <li class="list">{{ t("common-question-count", { count: assessmentSet.taskList.length}) }}</li>
        <li class="completed" :class="{check : isComplete}">{{ completeText }}</li>
      </ul>
    </div>
    <LazyLearningTaskMenu :task-list="assessmentSet.taskList"/>
  </li>
</template>

<script setup lang="ts">
import { computed, useRoute, useRouter } from "#imports";
import { LazyLearningTaskMenu } from "#components";
import { useI18n } from "vue-i18n";
import type { PropType } from "vue";
import { nextTick, onMounted } from "vue";
import {
  ProSkillAssureAssessmentSetModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentSetModel";

const { t } = useI18n();

const route = useRoute();
const router = useRouter();

const props = defineProps({
  index: {type: Number, default: () => 0},
  assessmentSet: { type: Object as PropType<ProSkillAssureAssessmentSetModel>, default: () => new ProSkillAssureAssessmentSetModel()},
});

const courseSkillWrap = ref<HTMLElement | null>(null);

const isComplete = computed(() => {
  return props.assessmentSet!.taskList.every(task => task.completeFlag);
})
const completeText = computed(() => {
  const completeLength = props.assessmentSet!.taskList.filter(task => task.completeFlag).length
  return `${t("common-completed")} ${completeLength} / ${props.assessmentSet!.taskList.length}`
})

onMounted(() => {
  nextTick(() => {
    if (courseSkillWrap.value) {
      courseSkillWrap.value.scrollIntoView()
    }
  })
})
</script>
